{
  "common": {
    "close_banner": "Fermer la bannière",
    "ok": "OK",
    "load_more": "Charger plus",
    "close_modal": "Fermer la fenêtre",
    "rows_per_page": "Lignes par page",
    "updated": "Mis à jour",
    "alert_view": "Vue d'alerte",
    "close_alert_button": "Fermer l'alerte",
    "clear_search": "Effacer la recherche"
  },
  "access_role_page": {
    "user_management": "Gestion des utilisateurs"
  },
  "comment_actions": {
    "aria_label": "actions de commentaire"
  },
  "comment_preview": {
    "edited": "Modifié",
    "deleted_message": "Ce commentaire a été supprimé."
  },
  "remove_comment": {
    "confirm_delete_title": "Êtes-vous sûr de vouloir supprimer ce commentaire?",
    "confirm_delete_content": "Cliquez sur confirmer pour supprimer ce commentaire"
  },
  "dashboard": {
    "weekly_activity_report": "Votre rapport d'activité hebdomadaire",
    "welcome_back": "Bon retour"
  },
  "pages": {
    "not_found_title": "La page que vous recherchiez n'existe pas.",
    "return": "Retour",
    "no_permission": "Vous n'avez pas la permission de voir cette page.",
    "back_to_dashboard": "Retour au tableau de bord"
  },
  "create_tab_menu": {
    "create_new_tab": "créer un nouvel onglet",
    "new_view": "Nouvelle {{label}}",
    "create_view": "Créer une vue",
    "new_contact_list": "Nouvelle liste de contacts",
    "new_company_list": "Nouvelle liste d'entreprises",
    "create_list": "Créer une liste",
    "new_generic_list": "Nouvelle liste générique",
    "new_embed_url": "Nouvelle URL intégrée",
    "new_pages": "Nouvelles pages",
    "create_pages": "Créer des pages",
    "new_campaign": "Nouvelle campagne",
    "new_activity_list": "Nouvelle liste d'activités"
  },
  "filter_has_changed": {
    "message": "Le filtre a été modifié, souhaitez-vous mettre à jour cet onglet ?",
    "update_tab": "Mettre à jour l'onglet"
  },
  "update_name_form": {
    "validation_required": "veuillez saisir un nom",
    "update_list_name": "Mettre à jour le nom de la liste",
    "name": "Nom"
  },
  "menu_handler": {
    "actions": "Actions"
  },
  "avatar_card": {
    "avatar_label": "avatar de {{name}}"
  },
  "filters": {
    "select_property_instruction": "Sélectionnez une propriété à filtrer",
    "company_in_hierarchy": "Entreprise dans la hiérarchie",
    "search_main_company_placeholder": "Tapez pour rechercher l'entreprise principale"
  },
  "key_activity": {
    "firm_wide": {
      "title": "Entreprise Entière",
      "tooltip": "Total des activités clés dans l'entreprise ce mois-ci",
      "this_month": "Ce Mois-ci"
    },
    "filters": {
      "basic": "Basique",
      "large": "Large",
      "all_employees": "Tous",
      "select_employee": "Sélectionner un Employé",
      "select_activity_category": "sélectionner la catégorie d'activité",
      "select_month_year": "sélectionner le mois et l'année"
    },
    "actions": {
      "log_new_activity": "Enregistrer une nouvelle activité",
      "update_aria_label": "modifier l'activité clé",
      "update_title": "modifier l'activité clé",
      "remove_aria_label": "supprimer l'activité clé",
      "remove_title": "supprimer l'activité clé"
    },
    "grid": {
      "loading_aria_label": "chargement des activités clés",
      "load_limit_message": "Il y a plus d'activités clés que celles affichées.",
      "show_less": "afficher moins",
      "show_more": "+{{count}} de plus"
    },
    "chart": {
      "business_development": "Activité de Développement Commercial",
      "lead_activity": "Activité de Prospection",
      "marketing_activity": "Activité Marketing"
    },
    "performance": {
      "current": "Actuel",
      "current_tooltip": "Vous avez enregistré {{count}} activités clés ce mois-ci",
      "best": "Meilleur",
      "best_tooltip": "Votre record personnel : {{count}} activités clés en un mois",
      "consecutive": "Consécutif",
      "weeks": "Semaines",
      "consecutive_tooltip": "Vous avez enregistré des activités clés hebdomadaires pendant {{count}} semaines",
      "longest": "Plus Long",
      "longest_tooltip": "Votre plus longue série : {{count}} semaines"
    }
  },
  "meetings": {
    "calendar_view": {
      "all": "Tout",
      "tasks": "Tâches",
      "external_meetings": "Réunions externes",
      "key_activities": "Activités clés",
      "select_all": "Tout sélectionner",
      "task_tooltip": "tâche"
    },
    "contact_table": {
      "show_less": "Afficher moins",
      "show_more": "Afficher plus"
    },
    "key_activity": {
      "activity": "Activité",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Modifier l'activité",
      "remove": "Supprimer",
      "view_activity_details": "voir les détails de l'activité"
    },
    "recent": {
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "create_task": "Créer une tâche",
      "create_note": "Créer une note",
      "no_recent_meetings": "Vous n'avez pas eu de réunion depuis un moment"
    },
    "slide": {
      "aria_label": "diapositive de réunion",
      "add_key_activity": "Ajouter une activité clé",
      "contacts_involved": "Contacts impliqués",
      "staff_involved": "Personnel impliqué",
      "companies": "Entreprises"
    },
    "upcoming": {
      "cancelled": "[Annulé]",
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "no_meetings_coming_up": "Aucune réunion à venir"
    }
  },
  "mobile_contact_request": {
    "contact_request_page": {
      "thank_you_message": "Merci d'avoir ajouté vos contacts. Vous pouvez maintenant fermer cette fenêtre.",
      "im_done": "J'ai terminé"
    },
    "header": {
      "instruction_text": "Veuillez sélectionner et ajouter vos contacts que vous souhaitez ajouter à la liste \"{{listName}}\". Une fois que vous avez ajouté vos contacts, cliquez sur \"J'ai terminé\"."
    },
    "my_contacts": {
      "my_contacts": "Mes Contacts",
      "company_type": "Type de société",
      "consent_status": "Statut de consentement",
      "no_contacts_message": "Il n'y a aucun contact à afficher ici"
    },
    "bulk_add": {
      "contact_list": "Liste de Contacts",
      "bulk_add_description": "Ajouter des contacts en lot à la liste",
      "adding_in_progress_message": "Le contact est en cours d'ajout. Veuillez actualiser la page pour voir la liste mise à jour.",
      "adding_in_progress_title": "Ajout de Contact en Cours",
      "add_selected": "Ajouter la Sélection"
    },
    "contacts_table": {
      "selected": "sélectionnés",
      "contact": "Contact",
      "company": "Société",
      "location": "Lieu",
      "last_interaction": "Dernière Interaction"
    },
    "objective_progress": {
      "thanks_for_update": "Merci pour la mise à jour :)"
    }
  },
  "my_lists": {
    "page": {
      "search_placeholder": "Rechercher le nom de la liste",
      "lists_header": "Listes",
      "create_list": "Créer une liste"
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "list_actions": "Actions de liste",
      "rename_list": "Renommer la liste",
      "share_list": "Partager la liste"
    },
    "navigation": {
      "other_lists": "Autres listes"
    },
    "empty_states": {
      "no_shared_list": "Aucune liste partagée",
      "your_list_is_empty": "Votre liste est vide",
      "no_lists_found": "Aucune liste trouvée",
      "no_search_results": "Nous n'avons trouvé aucune liste correspondant à votre recherche. Essayez d'utiliser des mots-clés différents ou créez une nouvelle liste"
    },
    "confirmations": {
      "archive_list_content": "Êtes-vous sûr de vouloir archiver cette liste ? Elle sera supprimée de la liste.",
      "archive_list_title": "Archiver la liste ?",
      "remove_user_title": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      "remove_user_content": "Cliquez sur confirmer pour supprimer"
    },
    "forms": {
      "list_name_required": "Veuillez saisir un nom de liste",
      "list_name": "Nom de la liste",
      "invitee_required": "Veuillez choisir au moins un invité",
      "invite": "Inviter",
      "enable_duplicate_contacts": "Autoriser les contacts en double",
      "duplicate_contacts_tooltip": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    },
    "share": {
      "invite_tab": "Inviter",
      "access_tab": "Accès",
      "success_message": "Votre liste a été partagée avec succès. Nous informerons les destinataires.",
      "owner": "Propriétaire",
      "loading_users": "Chargement des utilisateurs"
    }
  },
  "user_menu": {
    "logged_in_as": "Vous êtes connecté en tant que",
    "switch_account": "Changer de compte",
    "updated_contacts": "Contacts mis à jour",
    "help": "Aide",
    "individual_connect": "Connexion individuelle",
    "admin_connect": "Connexion administrateur ({{consentName}})"
  },
  "duplicate_goal": {
    "header": "Dupliquer l'opportunité",
    "aria_label": "dupliquer l'opportunité",
    "title": "Dupliquer l'opportunité"
  },
  "add_document_ui": {
    "add_document_aria_label": "ajouter un document",
    "add_document_header": "Ajouter un document",
    "or_separator": "- ou -"
  },
  "add_urls": {
    "document_urls_label": "URLs de documents (multiples)"
  },
  "archive_opportunity": {
    "confirm_content": "Cette action ne peut pas être annulée",
    "confirm_title": "Êtes-vous sûr de vouloir archiver cette opportunité ?",
    "archive_title": "Archiver l'opportunité"
  },
  "opportunity_grid": {
    "filters": {
      "assign_to": "Assigner à",
      "referral_source": "Source de référence",
      "date": "Date"
    },
    "actions_menu": {
      "opportunity_actions": "Actions d'opportunité",
      "actions": "Actions"
    }
  },
  "basic_opportunities_page": {
    "advanced_button": "Avancé",
    "create_opportunity_button": "Créer une opportunité",
    "all_opportunities_tab": "Toutes les opportunités"
  },
  "opportunity_preview": {
    "create_note": "Créer une note",
    "share_opportunity": "Partager l'opportunité",
    "update_opportunity": "Mettre à jour l'opportunité",
    "duplicate_opportunity": "Dupliquer l'opportunité",
    "archive_opportunity": "Archiver l'opportunité",
    "opportunity_number": "Opportunité #{{trackingNumber}}",
    "link": "Lien",
    "opportunity_for": "Opportunité pour",
    "industries": "Industries",
    "status": "Statut",
    "internal_owner": "Propriétaire interne",
    "key_contacts": "Contacts clés",
    "title_description": "Titre / Description",
    "tags": "Étiquettes",
    "proposed_fee": "Honoraires proposés",
    "team_involved": "Équipe impliquée",
    "referral_source": "Source de référence",
    "proposal_documents": "Documents de proposition",
    "linked_workspaces": "Espaces de travail liés",
    "view_original_email": "Voir l'e-mail original",
    "details": "Détails",
    "history": "Historique",
    "notes": "Notes"
  },
  "contacts": {
    "all_contacts": "Tous les contacts",
    "all_employees": "Tous les employés",
    "results": "Résultats",
    "company_type": "Type de société",
    "relationship_partner": "Partenaire relationnel",
    "company_hierarchy": "Hiérarchie de l'entreprise",
    "known_by": "Connu par",
    "consent_status": "Statut de consentement",
    "key_activity": "Activité clé"
  },
  "received_referrals": {
    "loading": {
      "loading_referrals": "Chargement des recommandations",
      "error_prefix": "Erreur: ",
      "load_limit_message": "Tableau des recommandations limité à 10 000 lignes. Contactez-nous pour des données supplémentaires."
    },
    "create": {
      "track_referral": "SuivreRecommandation"
    },
    "form": {
      "validation": {
        "company_required": "Veuillez saisir une entreprise"
      },
      "labels": {
        "referral": "Recommandation",
        "opportunity": "Opportunité",
        "client_company": "Entreprise Cliente (Entreprise Associée) *",
        "company_search_placeholder": "Tapez pour rechercher une entreprise",
        "client_contact": "Contact Client (Contact Clé)",
        "description": "Description",
        "description_placeholder": "Décrivez votre opportunité en une phrase",
        "opportunity_date": "Date de l'Opportunité",
        "date_placeholder": "date",
        "received_by": "Reçu par (Propriétaire Interne)",
        "received_by_placeholder": "Qui sera responsable de cette opportunité?",
        "sent_by": "Envoyé par (Source de Recommandation)",
        "sent_by_placeholder": "Qui a recommandé cette opportunité?",
        "more_fields": "PLUS DE CHAMPS",
        "status": "Statut",
        "tags": "Étiquettes",
        "proposed_fee": "Honoraires Proposés",
        "team_involved": "Équipe Impliquée",
        "team_involved_placeholder": "Équipe impliquée dans cette opportunité?"
      }
    },
    "grid": {
      "track_referral_header": "Suivre une Recommandation",
      "track_received_referral_aria": "suivre une recommandation reçue",
      "track_received_referral": "Suivre une Recommandation Reçue",
      "export_filename": "recommandations reçues",
      "open_slider_aria": "ouvrir le curseur"
    }
  },
  "reminder": {
    "create_reminder": "Créer un rappel",
    "reminder": "Rappel",
    "dismiss": "Ignorer",
    "dismiss_confirm_title": "Êtes-vous sûr de vouloir ignorer le rappel ?",
    "dismiss_confirm_content": "Cliquez sur confirmer pour ignorer le rappel.",
    "no_reminder_for_list": "Aucun rappel pour la liste actuelle",
    "send_to": "Envoyer à",
    "actions": "Actions",
    "select_date_field": "Sélectionner le champ de date",
    "validation_subject_required": "Veuillez ajouter un sujet",
    "validation_days_required": "Veuillez ajouter les jours de rappel",
    "validation_date_property_required": "Veuillez sélectionner une propriété de date",
    "validation_employees_required": "Veuillez sélectionner au moins 1 employé",
    "update_reminder_modal": "Mettre à jour le rappel",
    "create_reminder_modal": "Créer un rappel",
    "send_a": "Envoyer un",
    "subject": "Sujet",
    "reminder_text": "rappel",
    "days": "jours",
    "time_preposition": "Préposition temporelle",
    "to": "à",
    "remove_reminder": "Supprimer le rappel",
    "remove_confirm_title": "Êtes-vous sûr de vouloir supprimer ce rappel ?",
    "remove_confirm_content": "Cliquez sur confirmer pour supprimer le rappel.",
    "update_reminder_aria": "mettre à jour le rappel"
  },
  "review_contacts_table": {
    "clear_selection": "Effacer la sélection",
    "alert_message": "Examinez et gérez vos contacts entrants ici. En sélectionnant la case à côté d'un contact, vous pouvez les publier dans le CRM, les définir comme privés ou archiver leurs détails.",
    "contacts_selected": "{{count}} contacts sélectionnés",
    "contact_column": "Contact",
    "company_column": "Société",
    "location_column": "Lieu",
    "tags_column": "Tags",
    "last_interaction_column": "Dernière interaction"
  },
  "stay_in_touch": {
    "button": "Rester en contact",
    "modal_title": "Rester en contact",
    "set_frequency": "Définir la fréquence",
    "stay_in_touch_aria_label": "Rester en contact",
    "select_frequency": "Sélectionner la fréquence",
    "reminder_active_message": "Le rappel Rester en contact est actif, et les contacts ont été ajoutés à Mes contacts.",
    "no_reminders_set": "Vous n'avez défini aucun rappel Rester en contact",
    "due_date": "Date d'échéance",
    "contact": "Contact",
    "firm": "Cabinet",
    "last_interaction": "Dernière interaction"
  },
  "tags": {
    "delete_tag_confirm_title": "Êtes-vous sûr de vouloir supprimer ce tag ?",
    "remove_tag": "supprimer le tag",
    "tags_label": "Tags",
    "type_to_search": "Tapez pour rechercher des tags",
    "tags_placeholder": "Tags",
    "delete_tags_confirm_title": "Êtes-vous sûr de vouloir supprimer ces tags ?",
    "delete_tags": "Supprimer les tags",
    "bulk_remove_tag": "supprimer les tags en masse",
    "name_required": "Veuillez saisir un nom",
    "tag_update_notice": "Cela peut prendre jusqu'à 30 minutes pour mettre à jour le tag sur tous les contacts et sociétés.",
    "tag_created": "Tag créé.",
    "tag_name_label": "Nom du tag *",
    "name_tag_placeholder": "Nommez le tag",
    "tags_removal_notice": "Cela peut prendre jusqu'à 30 minutes pour que les tags soient supprimés de toutes les sociétés et contacts.",
    "tag": "Tag",
    "used": "Utilisé",
    "created_at": "Créé le",
    "actions": "Actions",
    "tag_removal_notice": "Cela peut prendre jusqu'à 30 minutes pour que le tag soit supprimé de toutes les sociétés et contacts.",
    "contacts": "Contacts",
    "companies": "Sociétés",
    "rename_tag": "renommer le tag",
    "order_by": "Trier par"
  },
  "version_alert": {
    "new_update_available": "Une nouvelle mise à jour est disponible, veuillez actualiser la page"
  },
  "auth": {
    "logged_out_message": "Vous avez été déconnecté, veuillez actualiser la page et vous reconnecter"
  },
  "mock": {
    "open_contact": "ouvrir le contact",
    "open_company": "ouvrir la société"
  },
  "grid": {
    "actions": {
      "more": "Plus",
      "manage_columns": "Gérer les colonnes",
      "reminder": "Rappel",
      "request_contacts": "Demander des contacts",
      "clean_list": "Nettoyer la liste",
      "add_comment": "Ajouter un commentaire",
      "copy_list_id": "Copier l'ID de la liste",
      "removed_history": "Historique des suppressions",
      "connected_to": "Connecté à {{campaignManager}}",
      "sync_with": "Synchroniser avec {{campaignManager}}"
    },
    "export": {
      "confirmation_message": "Voulez-vous exporter toutes les colonnes, y compris celles qui sont masquées ?",
      "all_columns": "Toutes les colonnes",
      "visible_columns_only": "Colonnes visibles uniquement"
    },
    "emarketing": {
      "settings": "Paramètres eMarketing",
      "sync_to_tools": "Synchroniser avec les outils eMarketing"
    }
  }
}
